import { useEffect, useRef, useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export default function DraftEditor({ packet, onSaved }) {
  const [tpls, setTpls] = useState([]);
  const [ids, setIds] = useState(packet.documents.map((d) => d.template_id));
  const [due, setDue] = useState(packet.due_date || "");
  const [state, setState] = useState("saved");
  const version = useRef(packet.version);
  const first = useRef(true);
  useEffect(() => { api.get("/templates").then((r) => setTpls(r.data.filter((t) => t.status === "active"))); }, []);
  useEffect(() => {
    if (first.current) { first.current = false; return undefined; }
    setState("saving");
    const t = setTimeout(async () => {
      try {
        const { data } = await api.patch(`/packets/${packet.id}`, { template_ids: ids, due_date: due, version: version.current });
        version.current = data.version;
        setState("saved");
        onSaved?.();
      } catch (e) { setState(`error: ${errMsg(e)}`); }
    }, 800);
    return () => clearTimeout(t);
  }, [ids, due]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <section className="bg-white border rounded-xl p-4" data-testid="draft-editor">
      <div className="flex items-center justify-between"><h3 className="font-semibold">Draft composition</h3>
        <span className={`text-xs ${state.startsWith("error") ? "text-red-700" : "text-slate-500"}`} data-testid="autosave-indicator">{state === "saving" ? "Saving..." : state === "saved" ? "All changes saved" : state}</span></div>
      <div className="grid sm:grid-cols-2 gap-2 mt-3">
        {tpls.map((t) => (
          <label key={t.id} className="flex items-center gap-2 border rounded-md p-2 text-sm cursor-pointer">
            <Checkbox checked={ids.includes(t.id)} onCheckedChange={(v) => setIds(v ? [...ids, t.id] : ids.filter((x) => x !== t.id))} data-testid={`draft-template-${t.id}`} />
            {t.name} <span className="text-slate-500">v{t.version}</span>
          </label>
        ))}
      </div>
      <Label className="block mt-3" htmlFor="draft-due">Due date</Label>
      <Input id="draft-due" type="date" value={due} onChange={(e) => setDue(e.target.value)} className="w-48 mt-1" data-testid="draft-due-input" />
    </section>
  );
}
